import 'leaflet/dist/leaflet.css';
import 'react-toastify/dist/ReactToastify.css';
import React, { Suspense } from 'react';
import Router from './routes';
import './App.css'
// Shared dashboard buttons need this background even when the user dashboard is not loaded.
import './user view src/views/UserDashBoard/SavedMap/SavedMap.css';
// Keep scoped editor styles available before any lazy route or hot update renders it.
import './views/City/EditCityLeftBar.css';
import {RouterProvider} from "react-router-dom";

const App = () => {
  return (
    <div>
      <Suspense fallback={<div className="flex items-center justify-center h-screen"><div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" /></div>}>
        <RouterProvider router={Router} />
      </Suspense>
    </div>
  );
};

export default App;
